import { Validators } from ".";
export var hasBranding = function(obj) {
    return "branding" in obj && Validators.isObject(obj.branding) && "vendorId" in obj.branding;
};

//# sourceMappingURL=window.js.map